import React from 'react';
import HiddenInput from 'shared/components/HiddenInput';

const SupplierSelected = (props) => {
  const { parameters, groupName } = props;
  const name = 'supplier_selected';

  return (
    <HiddenInput
      name={name}
      value={parameters[name]}
      groupName={groupName} />
  );
};

export default SupplierSelected;
